import MultiSelectCheck, { ISelectedItem } from "../../../../../components/Inputs/Selects/MultiSelectCheck";
import { CLASS_INPUTS } from "../../../../../constants/const";
import { OdsPgFilterProps } from "../types";

const ALL_VALUE = 'Todos';
const ALL_OPTION = { id: -1, value: ALL_VALUE };


const OdsPgFilter = ({ columns }: OdsPgFilterProps) => {
    // si una columna no tiene opciones, no se muestra su select
    const columnsWithOptions = columns.filter(column => column.options.length > 0);

    if (!columnsWithOptions.length) return null;

    return (
        <div className='border-y border-brand-green-7'>
            <div className='p-4 flex gap-4'>
                {columnsWithOptions.map((column) => {
                    const showAllOption = !!column.onSelectAll && column.options.length > 1;
                    const isAllSelected = column.options.every(option => column.selectedValues.includes(option.value));
                    // "Todos" se marca como seleccionado cuando están todas las opciones
                    const selectedItems: ISelectedItem[] = showAllOption && isAllSelected
                        ? [{ label: column.title, value: ALL_VALUE }, ...column.selectedItems]
                        : column.selectedItems;

                    return (
                        <MultiSelectCheck
                            key={column.title}
                            options={showAllOption ? [ALL_OPTION, ...column.options] : column.options}
                            onSelect={(item) => {
                                if (showAllOption && item.value === ALL_VALUE) {
                                    column.onSelectAll?.(!isAllSelected);
                                    return;
                                }
                                const option = column.options.find(o => o.value === item.value);
                                if (option) column.onSelect(option);
                            }}
                            selectedItems={selectedItems}
                            label={column.title}
                            disabled={!column.visible}
                            className={CLASS_INPUTS}
                            variant='outline-black'
                        />
                    );
                })}
            </div>
        </div>
    )
}

export default OdsPgFilter